var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose = function SvgClose(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.803 4.19608C12.0656 4.45753 12.0656 4.88141 11.803 5.14286L8.93387 7.99997L11.8031 10.8571C12.0656 11.1186 12.0656 11.5425 11.8031 11.8039C11.5405 12.0654 11.1149 12.0654 10.8523 11.8039L7.9831 8.94675L5.14768 11.7703C4.88513 12.0317 4.45946 12.0317 4.19691 11.7703C3.93436 11.5088 3.93436 11.0849 4.19691 10.8235L7.03234 7.99997L4.19696 5.17651C3.93442 4.91506 3.93442 4.49118 4.19696 4.22973C4.45951 3.96829 4.88518 3.96829 5.14773 4.22973L7.9831 7.0532L10.8523 4.19608C11.1148 3.93464 11.5405 3.93464 11.803 4.19608Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "close.b606b98caa92e72dda2ac1d11d97f18b.svg";